import { useEffect, useState } from "react";
import { axios, isAxiosError } from "@root/libs/axios";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

type CredentialStatusOption = {
  willFlag: boolean;
  label: string;
};

type CredentialItem = {
  userCredentialItemId: number;
  name: string;
  credentialStatusOptions: CredentialStatusOption[];
};

type CredentialResponse = {
  requiredCredentials: CredentialItem[];
  optionalCredentials: CredentialItem[];
};

type ErrorResponse = {
  error: string;
};

export const useCredentialOptions = (credentialUrl: string, jobTypeExperienceId: number) => {
  const [credentials, setCredentials] = useState<CredentialResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobTypeExperienceId) {
      setCredentials(null);
      setError(null);
      return;
    }

    const fetchCredentials = async () => {
      setError(null);

      try {
        const response = await axios.get<CredentialResponse>(credentialUrl, {
          params: { job_type_experience_id: jobTypeExperienceId },
        });

        setCredentials(response.data);
      } catch (err) {
        const fallbackMessage = "時間を置いて再度お試しください";

        if (isAxiosError<ErrorResponse>(err)) {
          const errorMessage = err.response?.data?.error ?? fallbackMessage;
          setError(errorMessage);
          sendErrorLog(new Error(errorMessage));
        } else {
          setError(fallbackMessage);
          sendErrorLog(new Error(fallbackMessage));
        }

        setCredentials(null);
      }
    };

    fetchCredentials();
  }, [credentialUrl, jobTypeExperienceId]);

  return { credentials, error };
};
